import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { fetchProjectsCms } from '../../services/project';

export const storeName = 'projectEntity';

export const projectEntity = createModel<RootModel>()({
  name: storeName,
  state: { codes: {} },
  reducers: { ...baseEntity },
  effects: (dispatch: RematchDispatch<typeof projectEntity>) => ({
    async fetchProject(payload) {
      const resp = await fetchProjectsCms(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saves(data.content);
      return resp;
    },
  }),
});

export default projectEntity;
